module.exports = __webpack_public_path__ + "assets/img/SC3IMG001.5a177c09.png";